<template>
    <div v-if="result" class="cabinet">
        <cabinet-menu v-if="result.blockMenu" :result="result.blockMenu">
            <div class="cabinet__block" v-if="result && screenWidth < 768">
                <router-view />
            </div>
        </cabinet-menu>
        <div v-if="result && screenWidth >= 768" class="cabinet__block">
            <router-view />
        </div>

    </div>
</template>

<script>
import { mapState } from 'vuex';

const defaultData = process.env.NODE_ENV === 'production' ? {} : {
    type: 'cabinet-select' || 'cabinet-profile' || 'cabinet-history',
    "blockMenu": {
        "items": []
    },
}
export default {
    name: 'cabinet-vue',
    props: {
        result: {
            type: [Object],
            default: () => defaultData
        }
    },
    data() {
        return {

        }
    },
    methods: {

    },
    computed: {
        getCurrentData() {
            const result = this.result;
            if (result) {
                return result.profileData || result.historyData;
            }
        },
        ...mapState({
            componentName: ({personalCabinet}) => personalCabinet?.data?.vueComponentName,
            cabinet: ({personalCabinet}) => personalCabinet?.data,
        }),

    },
    mounted() {
        if (App.debug) {
            console.log('Component: cabinet', this.result);
        }

    },
}
</script>

<style lang="scss" scoped>
    .cabinet {
        display: grid;
        grid-template-columns: 1fr;
        grid-column-gap: 4px;
        margin-bottom: 80px;
        width: calc(100% + 30px);
        transform: translateX(-15px);
        @include point-md {
            grid-template-columns: 252px 1fr;
            width: auto;
            transform: none;
        }
        @include point-lg {
            grid-template-columns: 332px 1fr;
        }
        &__block{
            padding:  0 16px 16px;
            background-color: #fff;
            @include point-md{
                padding: 24px;
            }
            @include point-lg{
                padding: 18px 32px;
            }
        }
    }
</style>